<script setup lang="ts">
import { useWorkspace } from '~/stores/workspace'

const router = useRouter()
const workspace = useWorkspace()
</script>

<template>
  <div class="policy-mode-editor-layout bg-white">
    <header
      class="sticky top-0 z-30 flex h-10 items-center justify-between border-b border-neutral-200 bg-white px-6"
    >
      <div class="flex items-center gap-2">
        <LogoRialtic class="h-6" icon />
        <p class="subtitle-2 text-neutral-800">
          {{ workspace.activeConnector?.name }}
        </p>
      </div>
      <UiBtnClose @click="router.back()" />
    </header>

    <slot />
  </div>
</template>

<style scoped>
.policy-mode-editor-layout {
  @apply grid h-dvh;
  grid-template-rows: 40px auto;
}
</style>
